export default "__VITE_ASSET__5cc03d95__"